import React from 'react'

interface ProgressProps {
  percent: number
}

const Progress: React.FC<ProgressProps> = (
  props: ProgressProps,
): JSX.Element => {
  const { percent = 0 } = props

  const base = 'progress'
  const styleProgress = {
    width: `${percent}%`,
  }

  return (
    <div className={`${base}__layout`}>
      <div className={`${base}__bg`} style={styleProgress} />
    </div>
  )
}

export default Progress
